.wrapper {
  :global(.ant-layout-sider-children) {
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
  }

  :global(.ant-menu) {
    flex: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
}

.sidebarCollapseButton {
  position: absolute;
  top: 47px;
  right: calc(var(--ant-control-height-sm) / 2 * -1);
}
